import { Editor, Path, Transforms } from 'slate';
import { ReactEditor } from 'slate-react';
import { AulaEditorInstance } from '../types';

/**
 * handleBlockMove
 *
 * Handles moving blocks around via the drag handle
 */
export const handleBlockMove = (
  editor: AulaEditorInstance,
  event: React.DragEvent<HTMLDivElement>,
  _to?: Path
) => {
  const { selection } = editor;
  const data = event.dataTransfer;

  /**
   * We only want to execute this handler if there is a text-block event
   */
  if (selection != null && data.files.length === 0) {
    const dropPath = _to || [
      Editor.path(editor, ReactEditor.findEventRange(editor, event))[0],
    ];

    /**
     * When dropping on top block we want to move the block to index 0,
     * otherwise we want to adjust the index by 1 if we're moving a block up
     * to account for the shift
     */
    const to = [
      dropPath[0] > 0 && Path.isBefore(dropPath, selection.focus.path)
        ? dropPath[0] + 1
        : dropPath[0],
    ];

    event.stopPropagation();
    Transforms.moveNodes(editor, { at: selection, to, mode: 'highest' });
  }
};
